<template>
  <q-form class="license-state-dialog-container center relative scroller">
    <div
      class="row items-center icon-container"
      style="padding: unset"
    >
      <img
        :src="License_X_icon"
        alt="License-X-icon"
      />
    </div>
    <div class="dialog-title text-center">{{ $t('generic.licenseStates.licenseDisabled.title') }}</div>
    <div class="dialog-description text-center">
      <div class="gordita-400-16-r">
        <span>{{ $t('generic.licenseStates.licenseDisabled.description.a') }}</span>
        <br /><span>{{ $t('generic.licenseStates.licenseDisabled.description.b') }}</span>
        <a
          :href="supportMailUrl"
          class="link-font text-brand_almost_black"
          >{{ supportMailUrl.split(':')[1] }}</a
        >
        <span>{{ $t('generic.licenseStates.licenseDisabled.description.c') }}</span>

        <div
          v-if="isLicenseKeyActivated"
          style="margin-top: 30px"
        >
          {{ $t('generic.licenseStates.activateNewLicense') }}
        </div>
      </div>

      <div
        v-if="!isLicenseKeyActivated"
        class="input-container"
      >
        <q-input
          :data-testid="elementsId.dialogs.licenseDialogs.licenseDisabledDialog.licenseKeyInput"
          v-model="licenseKey"
          class="license-key-input"
          label="Enter a different license key"
          bg-color="white"
          outlined
          lazy-rules
          input-class="brand_almost_black license-key-input"
          no-error-icon
          @keypress="handleKeyPress($event)"
        />
      </div>

      <div
        class="button-container"
        :style="isLicenseKeyActivated ? 'margin-top:56px' : ''"
      >
        <q-spinner-dots
          v-if="licensePending"
          class="text-brand_almost_black"
          style="align-items: center"
          size="4em"
        />
        <q-btn
          v-else
          :data-testid="elementsId.dialogs.licenseDialogs.licenseDisabledDialog.submitButton"
          ref="sumbit-button"
          flat
          type="submit"
          rounded
          no-caps
          tabindex="3"
          :disabled="!licenseKey && !isLicenseKeyActivated"
          :class="{ disabled: !licenseKey && !isLicenseKeyActivated }"
          class="submit-button load-key-btn incredi-button-ibx primary-strong enable focus-be-gone"
          :label="isLicenseKeyActivated ? 'Deactivate' : $t('generic.licenseStates.loadKey')"
          @click.prevent.stop="isLicenseKeyActivated ? deactivateLicense(license?.key) : submitLicense()"
        />
        <div
          v-if="deactivateLicenseFailed"
          class="deactivate-fail-text ibf-gordita-12-m"
        >
          Operation failed
        </div>
      </div>
    </div>

    <div
      v-if="isLicenseKeyActivated"
      :data-testid="elementsId.dialogs.licenseDialogs.licenseDisabledDialog.refreshNowButton"
      class="dialog-footer text-center"
    >
      <span class="gordita-regular-14 footer-text">{{ $t('generic.licenseStates.licenseDisabled.footerText') }}</span>
      <span
        :class="{ animate: refreshLicenseSpinner }"
        class="gordita-500-14-m refresh-btn focus-be-gone"
        @click.prevent.stop="refreshLicense(false, license?.key)"
      >
        <span style="padding-right: 4px">{{ $t('generic.licenseStates.refreshNow') }}</span>
        <q-icon
          size="16"
          name="icon-uil uil-sync"
          class="spinner-icon"
        />
      </span>
    </div>
  </q-form>
</template>

<script>
import elementsId from '@/const/elementIds.json';
import License_X_icon from '@/assets/images/LicenseStatesDialogs/license-error-icon.svg';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { defineComponent, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { licenseDialogMixins } from './licenseDialogMixins';

export default defineComponent({
  name: 'LicenseDisabledDialog',
  mixins: [licenseDialogMixins],
  props: {
    isLicenseKeyActivated: {
      type: Boolean,
    },
  },
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);
    const GQL_useLicenseInfoQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
    return { GQL_useLicenseInfoQuery, elementsId };
  },
  data() {
    return {
      License_X_icon,
    };
  },
  computed: {
    license() {
      return this.GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license;
    },
  },
});
</script>

<style scoped lang="scss">
@import './LicenseDialogsCommonStyle';
</style>
